import { render, staticRenderFns } from "./LongText.vue?vue&type=template&id=27a6711e&scoped=true&"
import script from "./LongText.vue?vue&type=script&lang=js&"
export * from "./LongText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27a6711e",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VTextarea})


/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\camha\\projects\\netcountable-app\\truple\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('27a6711e')) {
      api.createRecord('27a6711e', component.options)
    } else {
      api.reload('27a6711e', component.options)
    }
    module.hot.accept("./LongText.vue?vue&type=template&id=27a6711e&scoped=true&", function () {
      api.rerender('27a6711e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/surveys/questions/LongText.vue"
export default component.exports